import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Divider, Layout, Typography } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { iconMapping } from '../../../configs/AppsConfig';

import PortfoliosTable from './components/PortfoliosTable';
import PageHeader from '../../../components/PageHeader';
import Placeholder from "../../../components/Placeholder";

import { selectPortfoliosWithUserUpdates } from "../../../store/slices/portfolios.slice";
import { selectUserFields } from '../../../store/slices/user.slice';

import usePortfolios from "./usePortfolios";







const PortfoliosCollection = () => {
    const items = useSelector(selectPortfoliosWithUserUpdates);
    const { countPortfoliosWithSignals } = usePortfolios(items);

    const navigate = useNavigate();
    const portfolioPrefix = useSelector((state) => selectUserFields(state, 'settings.portfolio_prefix'));

    const Empty = ()=>{
        const Buttons = (
            <ButtonGroup>
                <Button variant={'contained'} onClick={() => navigate('/builders/model')}>Personalize Model</Button>
                <Button variant={'text'} onClick={() => navigate('/builders/portfolio')}>Build Sleeve</Button>
            </ButtonGroup>
        )
        return (
            <Placeholder text={'No Portfolios Available'}
                               action={<Buttons/>}
                    />
        )
    }

    const formattedPortfolios = React.useMemo(() => {
        return items.map((portfolio) => ({
            ...portfolio,
            inceptionDate: new Date(portfolio.inception_date * 1000).toLocaleDateString(),
        })).filter(portfolio => portfolio?._user?.hasOwnProperty?.('in_use'))
    }, [items]); // Include updateFlag to trigger re-calculation when flag toggles


    return (
          <Layout>
            <Layout.Content>
              {formattedPortfolios.length > 0 ? (
                <PortfoliosTable portfolios={formattedPortfolios} prefix={portfolioPrefix} />
              ) : <Placeholder />}
            </Layout.Content>
          </Layout>
  );
};

export default PortfoliosCollection;